import { render, staticRenderFns } from "./UberMenus.vue?vue&type=template&id=a21d70a6"
import script from "./UberMenus.vue?vue&type=script&lang=js"
export * from "./UberMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports